import { render, staticRenderFns } from "./AdminCommentsView.vue?vue&type=template&id=55a8ba50&scoped=true&"
import script from "./AdminCommentsView.vue?vue&type=script&lang=js&"
export * from "./AdminCommentsView.vue?vue&type=script&lang=js&"
import style0 from "./AdminCommentsView.vue?vue&type=style&index=0&id=55a8ba50&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a8ba50",
  null
  
)

export default component.exports